import React, { memo } from 'react';
import styled from 'styled-components';

import {
  SkeletonLarge as LogLargeSkeletonIcon,
  SkeletonMedium as LogMediumSkeletonIcon,
  SkeletonSmall as LogSmallSkeletonIcon,
} from '@icons/communication';
import { ValueOf } from '@utils/tsUtils';

export const SIZES = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
};

interface ILogSkeleton {
  className?: string;
  size?: ValueOf<typeof SIZES>;
}

const skeletonIcon = size => {
  switch (size) {
    case SIZES.SMALL:
      return <LogSmallSkeletonIcon width={228} height={36} />;
    case SIZES.MEDIUM:
      return <LogMediumSkeletonIcon width={228} height={49} />;
    case SIZES.LARGE:
      return <LogLargeSkeletonIcon width={228} height={84} />;
    default:
      return null;
  }
};

const LogSkeleton = ({ size = SIZES.MEDIUM, ...props }: ILogSkeleton) => (
  <StyledItem {...props}>{skeletonIcon(size)}</StyledItem>
);

const StyledItem = styled.div`
  padding-bottom: 10px;
  > * {
    animation: fade 0.1s ease;
    @keyframes fade {
      from {
        opacity: 0;
      }
    }
  }
`;

export default memo(LogSkeleton);
